import { Directive, EventEmitter, Output, AfterViewInit, ElementRef, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';

@Directive({
  selector: '[finAfterViewInit]',
  standalone: false,
})
export class AfterViewInitDirective implements AfterViewInit {
  private elementRef = inject(ElementRef);
  private platform = inject(PLATFORM_ID);

  @Output() finAfterViewInit: EventEmitter<ElementRef> = new EventEmitter<ElementRef>();

  ngAfterViewInit(): void {
    if (isPlatformServer(this.platform)) {
      return;
    }

    setTimeout(() => {
      this.finAfterViewInit.emit(this.elementRef);
    }, 0);
  }
}
